import React, { useCallback, useEffect, useMemo, useState } from 'react';

interface UseDropZone {
  isDropZoneVisible: boolean;
  dragHandlers: {
    onDragEnter: React.DragEventHandler;
    onDragOver: React.DragEventHandler;
    onDragLeave: React.DragEventHandler;
    onDrop: React.DragEventHandler;
  };
}

export const useDropZone = (onDrop: (e: React.DragEvent) => void | undefined): UseDropZone => {
  const [showDropZone, setShowDropZone] = useState<boolean>(false);

  const handleDrop = useCallback(
    (e: React.DragEvent) => {
      e.preventDefault();
      setShowDropZone(false);
      onDrop(e);
    },
    [onDrop],
  );

  const leave = useCallback((e: React.DragEvent) => {
    e.preventDefault();
    setShowDropZone(false);
  }, []);

  useEffect(() => {
    const enter = (e: DragEvent) => {
      e.preventDefault();
      setShowDropZone(true);
    };

    window.addEventListener('dragenter', enter);
    window.addEventListener('dragover', enter);
    return () => {
      window.removeEventListener('dragenter', enter);
      window.removeEventListener('dragover', enter);
    };
  }, []);

  return useMemo(() => {
    const prevent = (e: React.DragEvent) => {
      e.preventDefault();
      e.stopPropagation();
    };

    return {
      isDropZoneVisible: showDropZone,
      dragHandlers: {
        onDrop: handleDrop,
        onDragEnter: prevent,
        onDragLeave: leave,
        onDragOver: prevent,
      },
    };
  }, [showDropZone, handleDrop, leave]);
};
